import zj_detail from '../pages/zj_detail/zj_detail'
import zj_share from '../pages/zj_share/zj_share'
import zj_content from '../pages/zj_content/zj_content'
import zj_classShare from '../pages/zj_classShare/zj_classShare'
import zj_notify from '../pages/zj_notify/zj_notify'
import mp_web from '../pages/mp_web/mp_web'
import zj_exam from '../pages/zj_exam/index'

export default [
  {
    path: '/zj_detail',
    component: zj_detail,
  },
  {
    path: '/zj_share/:id',
	name:'zj_share',
    component: zj_share,
  },
  {
    path: '/zj_content/:type/:corpId',
	name:'zj_content',
    component: zj_content,
  },
  {
    path: '/zj_classShare/:id',
	  name:'zj_classShare',
    component: zj_classShare,
  },
  {
    path: '/zj_notify/:id',
	  name:'zj_notify',
    component: zj_notify,
  },
  {
    path: '/',
    redirect: '/zj_detail'
  },
    {
    path: '/mp_web',
    component: mp_web
  },
  {
    path: '/zj_exam_23yj',
    component: zj_exam
  },
  {
    path:'/cwbook/:id',
    component: () => import('@/pages/active/active1'),
  }
]
